






















































































import { defineComponent, ref, watch } from '@vue/composition-api';
import { usePhysicalExercise } from '../composables/usePhysicalExercise';
import { DataTableOptions } from '@/types/datatables';

import PhysicalExerciseCreateForm from '../components/PhysicalExerciseCreateForm.vue';
import PhysicalExerciseEditForm from '../components/PhysicalExerciseEditForm.vue';

export default defineComponent({
  name: 'PhysicalExercise',
  components: {
    PhysicalExerciseCreateForm,
    PhysicalExerciseEditForm,
  },
  setup() {
    const {exercises, total, loading, fetchExercises} = usePhysicalExercise();
    const dialog = ref(false);
    const editDialog = ref(false);
    const selectedExercise = ref<any>(null);
    const options = ref<DataTableOptions>({
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    });

    const headers = [
      {text: 'Name', value: 'name'},
      {text: 'Description', value: 'description'},
      {text: 'Instructor', value: 'instructor'},
      {text: 'Image', value: 'thumbnail'},
      {text: 'Video', value: 'video'},
      {text: 'Created At', value: 'created_at'},
      {text: 'Actions', value: 'actions', sortable: false},
    ];

    const loadItems = async () => {
      await fetchExercises({
        skip: (options.value.page - 1) * options.value.itemsPerPage,
        take: options.value.itemsPerPage,
        sortBy: options.value.sortBy[0],
        sortDesc: options.value.sortDesc[0],
      });
    };

    watch(options, async () => {
      await loadItems();
    });

    const handleSubmit = async () => {
      dialog.value = false;
      editDialog.value = false;
      await loadItems();
    };

    const handleEdit = async (exercise: any) => {
      selectedExercise.value = exercise;
      editDialog.value = true;
    };

    return {
      exercises,
      total,
      loading,
      options,
      headers,
      dialog,
      editDialog,
      selectedExercise,
      handleSubmit,
      handleEdit,
    };
  },
});
